<template>
  <div>
    <!-- <div class="body-wrap" v-if="page === 'form-survey'"> -->
    <div class="bgc">
      <h1
        v-if="(!pre_submitted && !submitted) || (pre_submitted && !submitted)"
      >
        {{ this.questionaire.title }}
      </h1>
      <h1 style="font-size: 25px" v-if="pre_submitted && submitted">
        {{ this.questionaire.title }}
        <span style="font-size: 20px"
          ><br />感謝您，填寫凝血功能異常評估表!</span
        >
      </h1>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12 mx-auto mt-5 pn n">
          <div id="wrapper" v-if="!pre_submitted && !submitted">
            <div class="col-12 col-md-6 mx-auto">
              <p class="total">共{{ this.total_question }}題</p>
            </div>
            <div class="container p">
              <div class="row">
                <div class="col-12 col-md-8 mx-auto mb-5">
                  <div class="quiz-container">
                    <div id="quiz">
                      <div
                        v-for="(question, index) in this.questionaire.question"
                        :key="question.uuid"
                      >
                        <div
                          class="slide active-slide"
                          v-if="current_slide == index"
                        >
                          <div class="question">
                            {{ index + 1 }}、 {{ question.question }}
                          </div>
                          <div
                            v-if="
                              question.question_type ==
                              'd064a34c-35fb-47b6-992d-3bc38f8d3182'
                            "
                            class="answers"
                          >
                            <label
                              v-for="(answer, score) in question.answer"
                              :key="answer.uuid"
                            >
                              <input
                                type="radio"
                                @change="
                                  onChangeResult(
                                    $event,
                                    question.question_type,
                                    index,
                                    question.uuid,
                                    question.is_question,
                                    score,
                                    answer.answer
                                  )
                                "
                                :name="'q' + (index + 1)"
                                :value="answer.uuid"
                              />
                              <div class="check">{{ answer.answer }}</div>
                            </label>
                          </div>
                        </div>

                        <div class="slide" v-if="current_slide != index">
                          <div class="question">
                            {{ index + 1 }}、 {{ question.question }}
                          </div>
                          <div
                            v-if="
                              question.question_type ==
                              'd064a34c-35fb-47b6-992d-3bc38f8d3182'
                            "
                            class="answers"
                          >
                            <label
                              v-for="(answer, score) in question.answer"
                              :key="answer.uuid"
                            >
                              <input
                                type="radio"
                                @change="
                                  onChangeResult(
                                    $event,
                                    question.question_type,
                                    index,
                                    question.uuid,
                                    question.is_question,
                                    score,
                                    answer.answer
                                  )
                                "
                                :name="'q' + (index + 1)"
                                :value="answer.uuid"
                              />
                              <div class="check">{{ answer.answer }}</div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="col-12 col-md-6 mx-auto mb-3">
                <div class="button">
                  <!-- Note: Tambah Routing -->
                  <button
                    @click.prevent="preSubmitResult"
                    v-show="this.btn_display.btn_submit"
                  >
                    提交
                  </button>

                  <button
                    id="next"
                    v-show="this.btn_display.btn_next"
                    v-if="this.current_slide != this.total_question - 1"
                    @click.prevent="showNextSlide"
                  >
                    下一題
                  </button>
                  <button
                    id="previous"
                    v-show="this.btn_display.btn_previous"
                    @click.prevent="showPreviousSlide"
                  >
                    前一題
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="wrapper" v-if="pre_submitted && !submitted">
            <div class="col-12 col-md-5 mx-auto">
              <form id="quiz">
                <div class="col-12 col-md-12 mx-auto mb-5 pt-5">
                  <div
                    class="box-1 none"
                    v-for="(question, index) in this.information.question"
                    :key="question.uuid"
                  >
                    <div
                      v-if="
                        question.question_type ==
                        'e15ec39d-0426-43ec-9525-296d9504c3f4'
                      "
                    >
                      <h2>{{ index + 1 }}、 {{ question.question }}</h2>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        @change="
                          onChangeResult(
                            $event,
                            question.question_type,
                            index,
                            question.uuid,
                            question.is_question
                          )
                        "
                        :name="'q' + (index + 1)"
                      >
                        <option selected value="0">請選擇</option>
                        <option
                          :value="answer.uuid"
                          v-for="answer in question.answer"
                          :key="answer.uuid"
                        >
                          {{ answer.answer }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="button-box">
                    <button
                      @click.prevent="submitResult"
                      class="btn btn-primary"
                    >
                      送出
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- <div class="body-wrap" v-show="page === 'thank-you'">
      <thankYou :result_uuid="this.result_uuid"> </thankYou>
    </div> -->
    <!-- <div class="container">
      <div class="row">
        <div class="col-12 col-md-12 mx-auto mt-5 mb-5" v-if="!this.submitted">
          <div id="wrapper">
            <div class="col-12 col-md-6 mx-auto">
              <div class="pt-3">
                <div class="word">
                  <h1>{{ this.questionaire.title }}</h1>
                </div>
              </div>
            </div>

            <form id="quiz">
              <div
                v-for="(question, index) in this.questionaire.question"
                :key="question.uuid"
              >
                <div
                  v-if="
                    question.question_type ==
                    'e15ec39d-0426-43ec-9525-296d9504c3f4'
                  "
                  class="box-1 none"
                >
                  <h2>{{ index + 1 }}. {{ question.question }}</h2>
                  <select
                    class="form-select"
                    aria-label="Default select example"
                    @change="
                      onChangeResult(
                        $event,
                        question.question_type,
                        index,
                        question.uuid
                      )
                    "
                    :name="'q' + (index + 1)"
                  >
                    <option selected value="0">請選擇</option>
                    <option
                      :value="answer.uuid"
                      v-for="answer in question.answer"
                      :key="answer.uuid"
                    >
                      {{ answer.answer }}
                    </option>
                  </select>
                  <br /><br />
                </div>

                <div
                  v-if="
                    question.question_type ==
                    'd064a34c-35fb-47b6-992d-3bc38f8d3182'
                  "
                  class="box-1 mt-4"
                >
                  <h2>{{ index + 1 }}. {{ question.question }}</h2>
                  <div v-for="answer in question.answer" :key="answer.uuid">
                    <label
                      ><input
                        type="radio"
                        @change="
                          onChangeResult(
                            $event,
                            question.question_type,
                            index,
                            question.uuid,
                            answer.answer
                          )
                        "
                        :name="'q' + (index + 1)"
                        :value="answer.uuid"
                      />
                      <span
                        style="
                          border-bottom: dotted 3px rgba(151, 151, 151, 0.667);
                          padding-bottom: 5px;
                        "
                        >{{ answer.answer }}</span
                      ></label
                    ><br />
                  </div>
                </div>

                <div class="button-box">
                  <button
                    @click.prevent="addResult(index)"
                    class="btn btn-primary"
                  >
                    下一
                  </button>
                </div>
              </div>
            </form>

            <div class="button-box">
              <button @click.prevent="submitResult" class="btn btn-primary">
                送出
              </button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
window.onload = () => {
  document.addEventListener(
    "touchstart",
    (event) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  let lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    (event) => {
      const now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );
};
</script>
      
<script>
import { apiGet as apiGetQuestion } from "@f/api/form_survey/get_question.js";
import { apiGet as apiGetInformation } from "@f/api/form_survey/get_information.js";
import { apiAdd as apiStoreAnswer } from "@f/api/form_survey/store_answer.js";

export default Vue.extend({
  // components: {
  //   ThankYou,
  // },
  data: function () {
    return {
      // page: "form-survey",
      questionaire_uuid: "33358816-11e3-4477-b752-3ff5748e3dcd",
      questionaire: {}, // Questionaire data from database, include question, and answer
      information: {},
      current_result: {
        // Which answer they choose now
        uuid: "",
        answer: "",
        question_uuid: "",
        score: 0,
      },
      score: 0,
      result: {}, // Final variable will be sent to the database
      result_detail: [], // Every choosen answer (after click Next)
      temp_result_detail: [], // Every choosen answer (before click Next)
      total_question: 0, // Total question need to be answered
      total_required_question: 0, // Total required question need to be answered
      total_information: 0, // Total question need to be answered
      total_required_information: 0, // Total required question need to be answered
      pre_submitted: false, // Status
      submitted: false, // Status
      passed: false,
      current_slide: 0,
      result_id: 0,
      result_uuid: "",
      score: 0,
      btn_display: {
        btn_previous: 0,
        btn_next: 0,
        btn_submit: 0,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.swalProccess("頁面加載中");
      try {
        await this.getQuestion(this.questionaire_uuid);
        await this.showSlide(this.current_slide);
        this.swalClose();
      } catch (err) {
        console.log("Init Error");
        console.log(err);
      }
    },

    // Get Question and Information Function
    async getQuestion(questionaire_uuid) {
      let query = "questionaire_uuid=" + questionaire_uuid;
      await apiGetQuestion(query)
        .then((res) => {
          if (res.data.code === 200) {
            // console.log(res.data.data);

            let questionaire = [];
            let question = [];
            let answer = [];
            let temp_question_id = "";

            let title = "";
            let description = "";

            let total_data = Object.keys(res.data.data).length;
            let total_required_question = 0;

            let index = 1;

            let prev_question_uuid = "";
            let prev_question = "";
            let prev_information = "";
            let prev_is_required = 0;
            let prev_is_question = 0;
            let prev_question_type = 0;

            res.data.data.forEach(function (d) {
              if (temp_question_id != "" && temp_question_id != d.question_id) {
                question.push({
                  uuid: prev_question_uuid,
                  question: prev_question,
                  information: prev_information,
                  is_required: prev_is_required,
                  is_question: prev_is_question,
                  question_type: prev_question_type,
                  answer: answer,
                });

                if (prev_is_required == 1) {
                  total_required_question += 1;
                }

                answer = [];
              }

              temp_question_id = d.question_id;

              prev_question_uuid = d.question_uuid;
              prev_question = d.question;
              prev_information = d.information;
              prev_is_required = d.is_required;
              prev_is_question = d.is_question;
              prev_question_type = d.question_type;

              answer.push({
                uuid: d.answer_uuid,
                answer: d.answer,
                next_question: d.next_question,
                question_id: d.question_id,
              });

              if (index == total_data) {
                question.push({
                  uuid: prev_question_uuid,
                  question: prev_question,
                  information: prev_information,
                  is_required: prev_is_required,
                  is_question: prev_is_question,
                  question_type: prev_question_type,
                  answer: answer,
                });

                if (prev_is_required == 1) {
                  total_required_question += 1;
                }

                answer = [];

                title = d.title;
                description = d.description;
              }
              index += 1;
            });

            questionaire = {
              question: question,
              title: title,
              description: description,
            };

            this.questionaire = questionaire;
            this.total_question = Object.keys(
              this.questionaire.question
            ).length;
            this.total_required_question = total_required_question;

            // console.log("Result");
            // console.log(this.questionaire);

            this.getInformation(this.questionaire_uuid);
          } else {
            this.swalError();
            console.log("Get Question Error I");
          }
        })
        .catch((err) => {
          console.log("Get Question Error II");
          console.log(err);
        });
    },
    async getInformation(questionaire_uuid) {
      let query = "questionaire_uuid=" + questionaire_uuid;
      await apiGetInformation(query)
        .then((res) => {
          if (res.data.code === 200) {
            // console.log(res.data.data);

            let information = [];
            let question = [];
            let answer = [];
            let temp_question_id = "";

            let title = "";
            let description = "";

            let total_data = Object.keys(res.data.data).length;
            let total_required_information = 0;

            let index = 1;

            let prev_question_uuid = "";
            let prev_question = "";
            let prev_information = "";
            let prev_is_required = 0;
            let prev_is_question = 0;
            let prev_question_type = 0;

            res.data.data.forEach(function (d) {
              if (temp_question_id != "" && temp_question_id != d.question_id) {
                question.push({
                  uuid: prev_question_uuid,
                  question: prev_question,
                  information: prev_information,
                  is_required: prev_is_required,
                  is_question: prev_is_question,
                  question_type: prev_question_type,
                  answer: answer,
                });

                if (prev_is_required == 1) {
                  total_required_information += 1;
                }

                answer = [];
              }

              temp_question_id = d.question_id;

              prev_question_uuid = d.question_uuid;
              prev_question = d.question;
              prev_information = d.information;
              prev_is_required = d.is_required;
              prev_is_question = d.is_question;
              prev_question_type = d.question_type;

              answer.push({
                uuid: d.answer_uuid,
                answer: d.answer,
                next_question: d.next_question,
                question_id: d.question_id,
              });

              if (index == total_data) {
                question.push({
                  uuid: prev_question_uuid,
                  question: prev_question,
                  information: prev_information,
                  is_required: prev_is_required,
                  is_question: prev_is_question,
                  question_type: prev_question_type,
                  answer: answer,
                });

                if (prev_is_required == 1) {
                  total_required_information += 1;
                }

                answer = [];

                title = d.title;
                description = d.description;
              }
              index += 1;
            });

            information = {
              question: question,
              title: title,
              description: description,
            };

            this.information = information;
            this.total_information = Object.keys(
              this.information.question
            ).length;
            this.total_required_information = total_required_information;

            // console.log("Result");
            // console.log(this.information);

            this.generateResult();
          } else {
            this.swalError();
            console.log("Get Question Error I");
          }
        })
        .catch((err) => {
          console.log("Get Question Error II");
          console.log(err);
        });
    },

    // Initial Function
    generateResult() {
      let total_data = this.total_question + this.total_information;
      let result_detail = [];
      let temp_result_detail = [];
      for (let i = 0; i < total_data; i++) {
        result_detail.push({
          answer_index: i,
          answer_uuid: "",
          answer: "",
          question_uuid: "",
        });

        temp_result_detail.push({
          answer_index: i,
          answer_uuid: "",
          answer: "",
          question_uuid: "",
        });
      }
      this.result_detail = result_detail;
      this.temp_result_detail = temp_result_detail;
    },
    showSlide(n) {
      // slides[currentSlide].classList.remove("active-slide");
      // slides[n].classList.add("active-slide");
      let crt_slide = n;

      if (crt_slide == 0) {
        this.btn_display.btn_previous = 0;
        // previousButton.style.display = "none";
      } else {
        this.btn_display.btn_previous = 1;
        // previousButton.style.display = "inline-block";
      }

      if (crt_slide == this.total_question - 1) {
        this.btn_display.btn_next = 0;
        this.btn_display.btn_submit = 1;
        // nextButton.style.display = "none";
        // submitButton.style.display = "inline-block";
      } else {
        this.btn_display.btn_next = 1;
        this.btn_display.btn_submit = 0;
        // nextButton.style.display = "inline-block";
        // submitButton.style.display = "none";
      }

      this.current_slide = crt_slide;
    },
    showNextSlide() {
      let respond = this.addResult(this.current_slide);

      // if (this.result_detail[13].answer == "男" && this.current_slide == 6) {
      //   this.temp_result_detail[7] = {
      //     answer_index: 7,
      //     answer_uuid: "6c605163-8ff9-479c-bcb0-532dd25b2c49",
      //     answer: "否",
      //     question_uuid: "8f9ebf81-e3e1-40c6-a8ee-b34663a4eec7",
      //     is_question: 1,
      //     score: 0,
      //   };
      //   let respond = this.addResult(7);

      //   if (respond) this.showSlide(this.current_slide + 2);
      // } else {

      if (respond) this.showSlide(this.current_slide + 1);
      // }
    },
    showPreviousSlide() {
      let respond = this.addResult(this.current_slide);

      // if (this.result_detail[13].answer == "男" && this.current_slide == 8) {
      //   this.temp_result_detail[7] = {
      //     answer_index: 7,
      //     answer_uuid: "6c605163-8ff9-479c-bcb0-532dd25b2c49",
      //     answer: "否",
      //     question_uuid: "8f9ebf81-e3e1-40c6-a8ee-b34663a4eec7",
      //     is_question: 1,
      //     score: 0,
      //   };
      //   let respond = this.addResult(7);

      //   if (respond) this.showSlide(this.current_slide - 2);
      // } else {

      if (respond) this.showSlide(this.current_slide - 1);
      // }
    },

    // Save Answer Function
    onChangeResult(
      event,
      type,
      i,
      question_uuid,
      is_question,
      score = 0,
      text = ""
    ) {
      if (type == "e15ec39d-0426-43ec-9525-296d9504c3f4") {
        let j = i + this.total_question;
        this.current_result.uuid =
          event.target.options[event.target.options.selectedIndex].value;
        this.current_result.answer =
          event.target.options[event.target.options.selectedIndex].text;
        this.current_result.question_uuid = question_uuid;
        this.current_result.is_question = is_question;
        this.current_result.score = score;

        this.temp_result_detail[j] = {
          answer_index: j,
          answer_uuid: this.current_result.uuid,
          answer: this.current_result.answer,
          question_uuid: this.current_result.question_uuid,
          is_question: this.current_result.is_question,
          score: this.current_result.score,
        };

        this.addResult(j);
      } else if (type == "d064a34c-35fb-47b6-992d-3bc38f8d3182") {
        this.current_result.uuid = event.target.value;
        this.current_result.answer = text;
        this.current_result.question_uuid = question_uuid;
        this.current_result.is_question = is_question;
        this.current_result.score = score;

        this.temp_result_detail[i] = {
          answer_index: i,
          answer_uuid: this.current_result.uuid,
          answer: this.current_result.answer,
          question_uuid: this.current_result.question_uuid,
          is_question: this.current_result.is_question,
          score: this.current_result.score,
        };
      }
    },
    addResult(i) {
      if (this.temp_result_detail[i].answer_uuid != "") {
        this.result_detail[i] = {
          answer_index: i,
          answer_uuid: this.temp_result_detail[i].answer_uuid,
          answer: this.temp_result_detail[i].answer,
          question_uuid: this.temp_result_detail[i].question_uuid,
          is_question: this.temp_result_detail[i].is_question,
          score: this.temp_result_detail[i].score,
        };

        return true;
      } else {
        this.swalMsg("請輸入問題編" + (i + 1) + "號", "", "error", "");
        return false;
      }
    },

    // Submit Function
    validateForm() {
      this.addResult(this.total_question - 1);

      for (i = 0; i < this.total_question; i++) {
        if (this.questionaire.question[i].is_required == 1) {
          if (this.result_detail[i].answer_uuid == "") {
            return i;
          }
        }
      }
      return -1;
    },
    postDataQuestionaire() {
      let total_score = 0;
      this.result_detail.forEach(function (d) {
        total_score += d.score;
      });

      let data = {
        result_detail: this.result_detail,
        questionaire_id: this.questionaire_uuid,
        score: total_score,
      };
      return data;
    },
    preSubmitResult() {
      this.pre_submitted = true;
    },
    submitResult() {
      this.swalProccess("資料傳送中...");

      // Form Validation
      let validated = this.validateForm();
      if (validated != -1) {
        this.swalMsg("請輸入問題編" + (validated + 1) + "號", "", "error", "");
      } else {
        let json = this.postDataQuestionaire();

        apiStoreAnswer(json)
          .then((res) => {
            if (res.data.code === 200) {
              this.swalClose();
              // this.getPageData(false); // Whas is this for ?

              // this.submitSurvey(res.data.data.uuid);

              // this.$router.push({ name: 'thank_you',
              //   query: { result_uuid: res.data.data.uuid }
              // });

              window.location =
                "/survey/thank-you?result_uuid=" + res.data.data.uuid;
              // this.page = "thank-you";

              this.swal().fire({
                title: "成功",
                icon: "success",
		text: "您的問卷已完成",
              });

              this.submitted = true;
            } else {
              console.log("Store Answer Error I");
              this.swalClose();
              // this.getPageData(false);
              this.swal().fire({
                title: "錯誤",
                icon: "error",
                text: res.data.msg,
              });
            }
          })
          .catch((err) => {
            console.log("Store Answer Error II" + err);
            this.swalClose();
            // store.dispatch('user/resetToken')
            this.swal().fire({
              title: "錯誤",
              icon: "error",
              text: err.msg,
              onClose: () => {
                // vue.close()
              },
            });
          });
      }
    },

    // After Submit Survey
    // submitSurvey(data) {
    //   this.page = "thank-you";
    //   this.result_uuid = data;
    //   console.log(this.result_uuid);
    //   // this.swalMsg(this.result_uuid, "", "", "");
    // },
  },
});
</script>

<style scoped>
/* Form 2 */
.form-select {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* Form 1 */
body {
  font-family: sans-serif;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

#wrapper h2 {
  /* margin: 10px 0 15px 0; */
  font-size: 20px;
}

label {
  margin: 7px;
}

#wrapper h1 {
  text-align: center;
  margin: 10px 0 15px 0;
  color: #0088c7b6;
  font-weight: bold;
  padding: 10px;
  border-bottom: solid 2px #0088c7b6;
}

.total {
  text-align: center;
  font-size: 25px;
  padding-top: 20px;
  margin-bottom: 0;
  font-weight: bold;
  color: #0088c78c;
}

.bgc {
  width: 100%;
  height: 300px;
  background-image: url("/assets/img/395.jpg");
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bgc h1 {
  color: white;
  text-align: center;
  text-shadow: 1px 2px 6px #191818;
  font-weight: bold;
  font-size: 48px;
}

.bgc h2 {
  color: white;
  text-align: center;
  text-shadow: 1px 2px 6px #191818;
  font-weight: bold;
}

.button {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  flex-direction: row-reverse;
  z-index: 999;
}

input:checked + span {
  color: #337ab7;
  font-weight: bold;
}

.word {
  padding: 0 20px;
}

.none {
  border-bottom: none !important;
  background-color: transparent !important;
}

#wrapper {
  background: white;
  /* padding: 10px 15px; */
  border-radius: 10px;
  height: 100%;
  box-shadow: 2px 2px 5px rgba(126, 126, 126, 0.667);
}

#wrapper .box-1 + .box-1 {
  padding-top: 20px;
}

#wrapper .box-1:nth-child(2n) {
  background-color: #d0e7ef5e;
}

.box-1 {
  /* border-bottom:dotted 2px #aaaa ; */
  margin-bottom: 15px;
}

.button-box .btn {
  font-size: 18px;
  padding: 10px;
  margin: 0 auto;
  color: white;
  border: 0;
  border-radius: 10px;
  margin-bottom: 10px;
  width: 100%;
}

.button-box a {
  display: block;
  width: 100%;
  display: flex;
  align-items: flex-end;
  height: 100px;
  padding-right: 20px;
  text-decoration: none;
}

.question {
  font-size: 26px;
  margin-bottom: 10px;
  background-color: #0088c78c;
  font-weight: bold;
  padding: 5px;
  color: white;
}

.answers {
  margin-bottom: 20px;
  text-align: left;
  display: inline-block;
  width: 100%;
}

.answers label {
  display: block;
  font-size: 20px;
  font-weight: bold;
}

input:checked + span {
  color: #337ab7;
  font-weight: bold;
}

button {
  font-size: 18px;
  padding: 10px;
  margin: 0 auto;
  color: white;
  border: 0;
  border-radius: 10px;
  background-color: #0088c7b6;
  width: 100px;
}

button:hover {
  background-color: #0088c783;
}

.slide {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.5s;
}

.active-slide {
  opacity: 1;
  z-index: 2;
  position: relative;
}

.quiz-container {
  height: 280px;
}

.p {
  padding: 20px;
}

.check {
  margin-left: 30px;
  margin-top: -30px;
}

/* ------------------------------------ */

@media screen and (max-width: 767px) {
  .question {
    font-size: 22px;
  }
  .bgc h1 {
    font-size: 36px;
    padding: 22px;
  }
  .bgc {
    background-attachment: scroll;
  }
  .quiz-container {
    height: auto;
  }
  .button {
    position: absolute;
    top: -60px;
    left: 0;
  }
  .n {
    margin-bottom: 250px !important;
  }
}

@media screen and (max-width: 320px) {
  .pn {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  .quiz-container {
    height: 570px;
  }
  .bgc h1 {
    font-size: 30px;
    padding: 22px;
  }
}
</style>
  
